module.exports = __webpack_public_path__ + "static/media/game-bosswrong.f50e0442.png";